module.exports = __webpack_public_path__ + "media/images/arakawa_seat_map_2025_01-0037219fa3d9deb64757bc63b106c7dc.png";